import React from "react"
import * as style from "./style.module.css"
import Layout from "/src/components/Layout"
import Seo from "/src/components/Seo"
import kv from "/src/images/vision/kv.jpg"
import FadeIn from "/src/components/FadeIn"

import vision01 from "/src/images/vision/vision01.jpg"
import vision02 from "/src/images/vision/vision02.jpg"
import vision03 from "/src/images/vision/vision03.jpg"
import vision04 from "/src/images/vision/vision04.jpg"
import vision05 from "/src/images/vision/vision05.jpg"

import growth01 from "/src/images/vision/growth01.jpg"

import aboutinterview from "/src/images/about/aboutinterview.jpg"

import yokoduna from "/src/images/vision/yokoduna.png"


const Page = () => {

  return (
    <Layout>
      <section className={style.topSec}>
        <div className={style.topVisual}>
          <img src={kv} alt="" />
        </div>
      </section>
      <FadeIn>
        <section className={style.mottosec}>
          <div className="contents">
            <img src={vision01} alt="" />
          </div>
        </section>
      </FadeIn>
        <section className={style.culturesec}>
      <FadeIn>
          <div className="contents">
            <img src={vision02} alt="" />
          </div>
      </FadeIn>
        </section>

        <section className={style.culture_contentsec}>
        <div className="contents">
          <div className={style.culture_content_wrap}>
            <FadeIn>
              <img src={vision04} alt="" />
            </FadeIn>
            <FadeIn>
              <img src={vision05} alt="" />
            </FadeIn>
          </div>
        </div>
      </section>
        <section className={style.growthSec}>
      <FadeIn>
          <div className="contents">
          <img src={vision03} alt="" />
          </div>
      </FadeIn>
        </section>

        <section className={style.trinitysec}>
      <FadeIn>
          <div className="container">
            <h2><span>介</span>護業界の横綱を目指して</h2>
            <div className={style.trinity_img}>
              <p>三位一体</p>
              <img src={yokoduna} alt="" />
              <p>躍進</p>
            </div>
          </div>
      </FadeIn>
        </section>
          <section className={style.about_interviewSec} id="vision01">
      <FadeIn>
            <div className={style.about_interview_box}>
              <div className={style.about_interview_img}>
                <p className={style.about_interview_company}>株式会社エムズ</p>
                <p className={style.about_interview_name}>代表取締役　松山　晃（税理士）</p>
                <img src={aboutinterview} alt="" />
              </div>
              <div className={style.about_interview_txt}>
                <h3>社会の課題をビジネスの力で解決し、永続的な変革を目指します。</h3>
                <p>「衣食足りて礼節を知る」という諺がありますが、今、格差の拡大により礼節心が薄れ、治安の悪化を感じる時代です。<br/>
                私は「未来の年表」を読んで深刻な未来を痛感し、子どもや孫たちの未来を守るために、今、自分に何ができるかという熱い思いが湧き上がりました。<br/>
                長年、税理士として多くの企業を支援してきた経験から得たノウハウを、社員と共有しながら社会に役立つ事業を次々と立ち上げること。<br/>
                それによって、物心両面で豊かさを実現する――それが私の使命であり、地域社会への恩返しです。<br/>
                私が信じるのは、資格や技術以上に「志」の大切さです。<br/>
                利他の心なくして魅力的な人間にはなれず、真の豊かさも得られません。<br/>
              「志」を持つ者が集まり、智慧を出し合い、イノベーションを生み出せば、きっと明るい未来が訪れるでしょう。<br/>
              これは世の原理原則です。<br/>
              我が社は、ご縁を大切にする「大家族主義」をモットーに、志ある仲間とともに、新しい
              価値を創造していきます。<br/>
              未来への第一歩を、共に踏み出しましょう！</p>
              </div>
            </div>
        </FadeIn>
          </section>
    </Layout>
  )
}

export default Page

export const Head = () => {
  const pageContext = {
  }

  return <Seo pageContext={pageContext} />
}
